import type { SVGProps } from "react";
export default function SvgChatGpt(props: SVGProps<SVGSVGElement>) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="1em"
			height="1em"
			fill="none"
			viewBox="0 0 24 24"
			{...props}
		>
			<g clipPath="url(#clip0_481_38)">
				<path
					fill="#74AA9C"
					d="M.01 5.77A5.76 5.76 0 0 1 5.77.01h12.46a5.76 5.76 0 0 1 5.76 5.76V24H5.77a5.76 5.76 0 0 1-5.76-5.76z"
				/>
				<path
					fill="white"
					d="M11.045 2.984a4.57 4.57 0 0 0-4.34 3.145l-.221 1.287v4.269c0 .213.11.403.293.512l3.436 1.98V8.313h.002v-.278l3.478-2.01a3.4 3.4 0 0 1 1.082-.396l-.335-1.136a4.53 4.53 0 0 0-3.395-1.508m0 1.172-.006.006c.795 0 1.56.274 2.171.782-.025.012-.074.043-.11.06L9.504 7.075a.58.58 0 0 0-.293.513v4.86l-1.547-.89V7.538a3.384 3.384 0 0 1 3.381-3.383"
				/>
				<path
					fill="white"
					d="M19.331 6.665a4.57 4.57 0 0 0-4.894-2.187l-1.226.453-3.696 2.134a.59.59 0 0 0-.298.51l.004 3.967 5.08-2.933.241-.138 3.479 2.007c.337.194.635.445.885.739l.816-.858a4.53 4.53 0 0 0-.39-3.694m-1.015.586-.008-.002c.398.688.542 1.487.408 2.27-.023-.015-.074-.042-.108-.064l-3.591-2.079a.58.58 0 0 0-.59.003l-4.21 2.43-.002-1.786 3.48-2.009a3.384 3.384 0 0 1 4.621 1.237"
				/>
				<path
					fill="white"
					d="M20.286 15.682a4.57 4.57 0 0 0-.553-5.333l-1.005-.834L15.03 7.38a.59.59 0 0 0-.59-.002l-3.434 1.986 5.08 2.933.24.14.001 4.016c0 .39-.067.773-.197 1.136l1.151.278a4.53 4.53 0 0 0 3.004-2.186m-1.015-.587-.002-.008a3.4 3.4 0 0 1-1.763 1.49c.002-.029 0-.086.002-.126l.005-4.15a.58.58 0 0 0-.298-.51l-4.21-2.43 1.547-.895 3.48 2.01c1.616.931 2.17 3 1.239 4.62"
				/>
				<path
					fill="white"
					d="M12.955 21.017c1.975 0 3.73-1.27 4.34-3.146l.221-1.287v-4.269a.59.59 0 0 0-.293-.512l-3.436-1.98v5.865h-.002v.278l-3.478 2.01a3.4 3.4 0 0 1-1.082.396l.335 1.136a4.53 4.53 0 0 0 3.395 1.509m0-1.173.006-.006c-.795 0-1.56-.274-2.171-.782.025-.012.074-.043.11-.06l3.596-2.071a.58.58 0 0 0 .293-.513v-4.86l1.547.89v4.019a3.384 3.384 0 0 1-3.381 3.383"
				/>
				<path
					fill="white"
					d="M4.669 17.335a4.57 4.57 0 0 0 4.894 2.187l1.226-.453 3.696-2.134a.59.59 0 0 0 .298-.51l-.004-3.967-5.08 2.933-.241.138-3.479-2.007a3.4 3.4 0 0 1-.885-.739l-.816.858a4.53 4.53 0 0 0 .39 3.694m1.015-.586.008.002a3.4 3.4 0 0 1-.408-2.27c.023.015.074.042.108.064l3.591 2.079a.58.58 0 0 0 .59-.003l4.21-2.43.002 1.786-3.48 2.009a3.384 3.384 0 0 1-4.621-1.237"
				/>
				<path
					fill="white"
					d="M3.714 8.318a4.57 4.57 0 0 0 .553 5.333l1.005.834L8.97 16.62a.59.59 0 0 0 .59.002l3.434-1.986-5.08-2.933-.24-.14-.001-4.017c0-.388.067-.772.197-1.135l-1.151-.278a4.53 4.53 0 0 0-3.004 2.185m1.015.587.002.008a3.4 3.4 0 0 1 1.763-1.49c-.002.029 0 .086-.002.126l-.005 4.15a.58.58 0 0 0 .298.51l4.21 2.43-1.547.895-3.48-2.01a3.384 3.384 0 0 1-1.239-4.62"
				/>
			</g>
			<defs>
				<clipPath id="clip0_481_38">
					<rect width={24} height={24} fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
}
